import React, { useState, useEffect } from 'react';
// Import styled components for Navbar UI
import {
  NavbarContainer,
  NavbarInner,
  NavbarBrand,
  BrandText,
  NavbarMenu,
  NavbarItem,
  ContactButton,
  NavbarToggle,
  HamburgerLine,
  GlobalNavbarStyles
} from './Navbar.styles';

// Navbar functional component
function Navbar({ toggle }) {
  // State to track if the mobile menu is open
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // State to track if the navbar should have a scrolled style
  const [isScrolled, setIsScrolled] = useState(false);

  // Effect to handle navbar style change on scroll
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // Determine if the navbar should be in "scrolled" state
      const shouldBeScrolled = scrollPosition > 50;
      
      if (shouldBeScrolled !== isScrolled) {
        setIsScrolled(shouldBeScrolled);
      }
    };

    // Initial check in case the page loads already scrolled
    handleScroll();
    
    // Add scroll event listener
    window.addEventListener('scroll', handleScroll, { passive: true });
    // Cleanup event listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isScrolled]);

  // Function to smoothly scroll to a section and close the menu

  const scrollToSection = (elementId) => {
    const element = document.getElementById(elementId)
    if(element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      })
    }
    setIsMenuOpen(false);
  }

  return (
    <>
      {/* Global styles for the navbar */}
      <GlobalNavbarStyles />
      {/* Navbar container with conditional 'scrolled' class */}
      <NavbarContainer className={isScrolled ? 'scrolled' : ''}>
        <NavbarInner>
          {/* Brand/logo section */}
          <NavbarBrand>
            <BrandText>Fahd Saleh</BrandText>
          </NavbarBrand>
          
          {/* Navigation menu, toggled active on mobile */}
          <NavbarMenu className={isMenuOpen ? 'active' : ''}>
            <NavbarItem onClick={() => scrollToSection('about')}>
              About
            </NavbarItem>
            <NavbarItem onClick={() => scrollToSection('experience')}>
              Experience
            </NavbarItem>
            <NavbarItem onClick={() => scrollToSection('skills')}>
              Skills
            </NavbarItem>
            <NavbarItem onClick={() => scrollToSection('projects')}>
              Projects
            </NavbarItem>
            <ContactButton onClick={toggle}>
              Contact
            </ContactButton>
          </NavbarMenu>

          {/* Hamburger menu toggle for mobile navigation */}
          <NavbarToggle 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <HamburgerLine className={isMenuOpen ? 'line-1-active' : ''} />
            <HamburgerLine className={isMenuOpen ? 'line-2-active' : ''} />
            <HamburgerLine className={isMenuOpen ? 'line-3-active' : ''} />
          </NavbarToggle>
        </NavbarInner>
      </NavbarContainer>
    </>
  );
}

export default Navbar;